module.exports = __webpack_public_path__ + "img/waaarp_logo_text_bk.223e1c8f.png";